import { createSlice } from "@reduxjs/toolkit";
import { fetchUserList } from "./thunk";
import { UserListSlice } from "types/users";
import { ERROR } from "types";


const initialState: UserListSlice = {
    count: 0,
    items: [],
    loading: true,
    page: 1,
    last_fetched_at: null,
    has_more: true,
    expired: true,
    error: null
}

const userListSlice = createSlice({
    name: 'userList',
    initialState,
    reducers: {
        markUserListExpired: (state) => {
            state.expired = true;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserList.pending, (state) => {
                state.loading = true;
                state.error = null
            })
            .addCase(fetchUserList.fulfilled, (state, action) => {
                state.items = action.payload.page === 1 ?
                    action.payload.userList.items :
                    [...state.items, ...action.payload.userList.items];

                state.count = action.payload.userList.count;
                state.page = action.payload.page;
                state.loading = false;
                state.has_more = action.payload.userList.count > state.items.length;
                state.last_fetched_at = Date.now();
                state.expired = false;
            })
            .addCase(fetchUserList.rejected, (state, action) => {
                state.loading = false;
                if(action.payload !== ERROR.CACHED)
                    state.error = action.payload || 'Failed to fetch users'
            })
    }
})

export const { markUserListExpired } = userListSlice.actions;

export default userListSlice.reducer;